<template>
  <el-dialog
    title="机器人命令"
    :visible="visible"
    width="860px"
    :destroy-on-close="true"
    :lock-scroll="false"
    custom-class="ele-dialog-form"
    @update:visible="updateVisible">
    <ele-pro-table
      ref="table"
      :datasource="url"
      :columns="columns"
      :toolkit="[]"
      height="420px"
      tool-class="ele-toolbar-actions">
      <template slot="toolbar">
        <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)">
          添加
        </el-button>
      </template>
      <template slot="status" slot-scope="{ row }">
        <el-switch
          v-model="row.status"
          :active-value="1"
          :inactive-value="2"
          @change="editStatus(row)" />
      </template>
      <template slot="action" slot-scope="{ row }">
        <el-button size="mini" type="primary" class="ele-btn-icon" @click="openEdit(row)">编辑</el-button>
        <el-popconfirm class="ele-action" title="确定删除该命令？" @confirm="remove(row)">
          <el-button size="mini" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
        </el-popconfirm>
      </template>
    </ele-pro-table>

    <el-dialog
      :title="isUpdate ? '编辑命令' : '添加命令'"
      :visible.sync="showEdit"
      width="480px"
      append-to-body
      :destroy-on-close="true"
      custom-class="ele-dialog-form">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
        <el-form-item label="业务动作" prop="action">
          <el-select v-model="form.action" class="ele-block" placeholder="请选择" @change="onActionChange">
            <el-option
              v-for="item in actionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="触发命令" prop="command">
          <el-input v-model.trim="form.command" maxlength="64" clearable placeholder="如 A0 / + / 下发 / 账单" />
        </el-form-item>
        <el-form-item label="显示名称" prop="title">
          <el-input v-model.trim="form.title" maxlength="64" clearable placeholder="请输入" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="form.sort"
            :min="0"
            :max="9999"
            controls-position="right"
            class="ele-fluid ele-text-left" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="2">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="save">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
const defaultForm = () => ({
  id: 0,
  action: 'okx_all',
  command: '',
  title: '',
  sort: 0,
  status: 1
});

export default {
  name: 'BotCommandConfig',
  props: {
    visible: Boolean
  },
  data() {
    return {
      url: '/botcommand/index',
      columns: [
        { prop: 'title', label: '名称', align: 'center', minWidth: 120, showOverflowTooltip: true },
        { prop: 'command', label: '触发命令', align: 'center', minWidth: 100, showOverflowTooltip: true },
        { prop: 'action_name', label: '业务动作', align: 'center', minWidth: 120, showOverflowTooltip: true },
        { prop: 'sort', label: '排序', align: 'center', width: 80 },
        { prop: 'status', label: '状态', align: 'center', width: 90, slot: 'status' },
        {
          columnKey: 'action',
          label: '操作',
          width: 160,
          align: 'center',
          resizable: false,
          slot: 'action',
          fixed: 'right'
        }
      ],
      actionOptions: [],
      showEdit: false,
      isUpdate: false,
      loading: false,
      form: defaultForm(),
      rules: {
        action: [{ required: true, message: '请选择', trigger: 'change' }],
        command: [{ required: true, message: '请输入', trigger: 'blur' }],
        title: [{ required: true, message: '请输入', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入', trigger: 'change' }]
      }
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadActionOptions();
        this.$nextTick(() => this.reload());
      }
    }
  },
  methods: {
    updateVisible(val) {
      this.$emit('update:visible', val);
    },
    reload() {
      if (this.$refs.table) {
        this.$refs.table.reload();
      }
    },
    loadActionOptions() {
      this.$http.get('/botcommand/actionOptions').then((res) => {
        if (res.data.code === 0) {
          this.actionOptions = res.data.data || [];
        }
      }).catch(() => {});
    },
    onActionChange(val) {
      if (this.form.title) return;
      const hit = this.actionOptions.find((item) => item.value === val);
      if (hit) this.form.title = hit.label;
    },
    openEdit(row) {
      if (row) {
        this.isUpdate = true;
        this.form = {
          id: row.id,
          action: row.action,
          command: row.command,
          title: row.title,
          sort: Number(row.sort) || 0,
          status: Number(row.status) || 1
        };
      } else {
        this.isUpdate = false;
        this.form = defaultForm();
      }
      this.showEdit = true;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        this.$http.post('/botcommand/edit', this.form).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.showEdit = false;
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    editStatus(row) {
      this.$http
        .post('/botcommand/status', { id: row.id, status: row.status })
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
          } else {
            row.status = row.status === 1 ? 2 : 1;
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          row.status = row.status === 1 ? 2 : 1;
          this.$message.error(e.message);
        });
    },
    remove(row) {
      this.$http.post('/botcommand/delete', { id: row.id }).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    }
  }
};
</script>
